exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body{font-family:Arial;overflow:visible}#left{width:380px;float:left;height:90vh;overflow-y:scroll;position:fixed;background-color:#fff}#left,#right{border:0 solid;margin-top:50px}#right{width:calc(100% - 380px);float:right;padding-left:20px}#topleft{width:380px;height:50px}#topleft,#topright{border:0 solid;position:fixed;top:0;background-color:#fff}#topright{width:calc(100% - 380px);left:388px;height:40px;padding-top:10px}.smallspacer{height:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-267ddf9d","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 103
// module chunks = 0